import {computed, defineComponent} from 'vue'

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlOlMapInfoItem',
    props: {
        tagName: {
            type: String,
            default: 'p'
        },
        label: {
            type: String,
            required: true
        }
    },
    setup() {
        const classes = computed(() => {
            return ['kl-ol-map-info__item']
        })
        return {
            classes
        }
    }
})
